import React from 'react'

import { IonIcon } from 'controls'

import { chart } from './styles'

const Chart = props => (
  <section className="chart">
    <header>{props.title}</header>
    {props.children}
    <footer className="series">
      <ul>
        {props.series.map((s, i) => (
          <li key={i}>
            <IonIcon icon="record" size="small" style={{ color: s.color }} />
            <span className="text">{s.text}</span>
          </li>
        ))}
      </ul>
    </footer>
    <style jsx>{chart}</style>
  </section>
)

export default Chart
